let ready = false;
let timeoutId: number | null = null;

export function installBootGuard(timeoutMs = 12_000) {
  if (typeof window === "undefined" || timeoutId !== null) return;
  timeoutId = window.setTimeout(() => {
    timeoutId = null;
    if (ready) return;
    const root = document.getElementById("root");
    if (!root || root.childElementCount > 0) return;
    root.innerHTML = `<main class="boot-fallback" role="alert"><h1>游戏未能完成启动</h1><p>本地存档不会因此被删除。请重新加载资源；仍然失败时不要清除网站数据。</p><button type="button" data-boot-reload>重新加载</button></main>`;
    root.querySelector("[data-boot-reload]")?.addEventListener("click", () => window.location.reload());
  }, timeoutMs);
}

export function signalBootReady() {
  ready = true;
  if (timeoutId !== null) window.clearTimeout(timeoutId);
  timeoutId = null;
}
